import { render, staticRenderFns } from "./CreateGroup.vue?vue&type=template&id=46cd0813&scoped=true&lang=html&"
import script from "./CreateGroup.vue?vue&type=script&lang=js&"
export * from "./CreateGroup.vue?vue&type=script&lang=js&"
import style0 from "./CreateGroup.vue?vue&type=style&index=0&id=46cd0813&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cd0813",
  null
  
)

export default component.exports